import { isFunction } from 'lodash'
import AccountManager from '../account'
import SettingsManager from '../settings'

import { BET_TYPE } from '../../constants'

import { getBetOutcome } from '../../utils'

/*
  Bet types processing map
*/
const betTypesProcessingMap = {

  [BET_TYPE.SINGLE]: (bet, betItems) => {
    const {
      acceptOddsChanges,
      lang
    } = SettingsManager.settings

    const currency = AccountManager.getAccountCurrency()

    return {
      acceptOddsChanges,
      acceptParameterChanges: acceptOddsChanges,
      betType: BET_TYPE.SINGLE,
      locale: lang,
      betMoney: {
        betAmount: bet.amount,
        currency
      },
      requestId: bet.requestId,
      outcomes: bet.outcomes
    }
  },

  [BET_TYPE.MULTIPLE]: (bet, betItems) => {
    const {
      acceptOddsChanges,
      lang
    } = SettingsManager.settings

    const currency = AccountManager.getAccountCurrency()

    return {
      acceptOddsChanges,
      acceptParameterChanges: acceptOddsChanges,
      betType: BET_TYPE.MULTIPLE,
      locale: lang,
      betMoney: {
        betAmount: bet.amount,
        currency
      },
      requestId: bet.requestId,
      outcomes: bet.outcomes
    }
  },

  [BET_TYPE.SYSTEM]: (bet, betItems) => {
    const {
      requestId,
      amount,
      winCombinationSize
    } = bet

    const {
      acceptOddsChanges,
      lang
    } = SettingsManager.settings

    const currency = AccountManager.getAccountCurrency()

    return {
      acceptOddsChanges,
      acceptParameterChanges: acceptOddsChanges,
      betType: BET_TYPE.SYSTEM,
      locale: lang,
      winCombinationSize,
      betMoney: {
        betAmount: amount,
        currency
      },
      outcomes: bet.outcomes,
      requestId
    }
  }
}

/*
  Processing BetItems and BetTypes, filtering empty
  Preparing data for sending to server-side

  Using for:
    - validateBets
    - placeBets
    - editBet
    - getMaxBet
    - getBetsLimits
*/

// Processing bet outcomes and creating order bet

export default class BetProcessor {
  processBet (bet, betItems) {
    const processing = betTypesProcessingMap[bet.betType || BET_TYPE.SINGLE]

    if (isFunction(processing)) {
      return processing(bet, betItems)
    }

    return false
  }

  processOrderBet (betItems) {
    const currency = AccountManager.getAccountCurrency()

    const {
      enableLiveOdds
    } = SettingsManager.settings

    const orders = betItems.map(betItem => {
      const outcome = getBetOutcome(betItem)

      return {
        acceptSportServiceChange: enableLiveOdds,
        betAmount: betItem.amount,
        betCurrency: currency,
        minDesiredOdds: (betItem.orderOdds / 100),
        outcomes: [
          {
            currentOdds: outcome.odds,
            marketStatus: outcome.marketStatus,
            sportService: betItem.event.sportService,
            eventId: betItem.event.id,
            marketId: betItem.market.id,
            outcomeId: betItem.outcome.id
          }
        ]
      }
    })

    return orders
  }
}
